import React from 'react';
import Header from '../component/Header';
import Footer from '../component/footer';

const TermsAndConditions = () => {
  return (
    <>
      <Header />
      <div className="min-h-screen flex flex-col bg-[#F4F5F7] font-sans text-gray-800">
  

      <main className="flex-grow w-full px-4 py-12 mx-auto max-w-7xl md:px-8 md:py-20">
        
        {/* Content Card */}
        <div className="bg-white rounded-[2.5rem] shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100 p-8 md:p-12 lg:p-16">
          
          {/* Page Header */}
          <div className="mb-12">
            <h1 className="text-3xl md:text-5xl font-extrabold text-[#113A28] tracking-tight mb-6">
              Terms and Conditions
            </h1>
            <div className="w-16 h-1.5 bg-[#4CE470] rounded-full mb-8"></div>
            
            <div className="space-y-4 leading-relaxed text-gray-600 ">
              <p className="font-bold text-[#113A28] text-lg">Terms of Use</p>
              <p>
                Thank you for using our product. The Service is provided by the merchant. By using our Services, you are agreeing to these terms.
              </p>
              <p className="font-bold text-[#113A28] text-lg mt-6">Dispute Resolution and Governing Law</p>
              <p>
                These Terms and Conditions of Use shall be governed by, and interpreted and enforced in accordance with, the laws of Cyprus applicable therein. Any claim, dispute or controversy shall be brought before the competent courts of Cyprus, and the parties attorney to the jurisdiction of such courts. This provision shall survive the termination of your right to use this Site.
              </p>
            </div>
          </div>

          <hr className="mb-12 border-gray-100" />

          {/* Legal Content Sections */}
          <div className="space-y-10 leading-relaxed text-gray-600">
            
            <section>
              <h2 className="text-xl md:text-2xl font-bold text-[#113A28] mb-4">1. Service</h2>
              <p className="mb-4">
                The Site and the Service, including all features and functionalities, instant streaming, our website and user interfaces, and all content and software associated therewith (the “service”) are offered under these Terms of Use (the “Terms”) together with the other agreements and documents referenced herein, including any future amendments to any of the foregoing (collectively, the “Agreement”).
              </p>
              <p>
                By using the Site and/or the Service, either as a Member User, a recipient of an e-mail from a registered user, or as a visitor (“you” or “your”), you agree that the Agreement is a binding contract between you and the merchant. If you do not wish to be bound to these Terms, then immediately stop using the Site and the Service.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-bold text-[#113A28] mb-4">2. The Agreement</h2>
              <p className="mb-4">
                You agree that no contract or agreement is formed and you have no rights to the Service, unless and until the merchant has agreed to provide you the Service.
              </p>
              <p className="mb-4">
                The merchant may amend or modify the Agreement at any time, without prior notice. The changes become effective immediately upon posting such amended or modified terms on the Site or if the merchant otherwise notifies you of such amended or modified terms. If you use the Site and/or the Service after such notice, you accept the Agreement as amended.
              </p>
              <p className="mb-4">
                We may refuse any application to use the Services for any reason whatsoever.
              </p>
              <p className="mb-4">
                To use our Services, you are required to create an account with us. In order to create an account, we require you to provide information about yourself: your email address, a password, as well as your name, surname and IBAN or credit/debit card details.
              </p>
              <p>
                You agree that we may send communications to your email address for customer service, confirmations, newsletters, product offers and other matters.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-bold text-[#113A28] mb-4">3. Your License</h2>
              <p className="mb-4">
                The merchant grants you a non-exclusive limited license to use the Services, including accessing and viewing the Content on a streaming-only basis through the Site, for personal, non-commercial purposes.
              </p>
              <p className="mb-4">
                You may only access and view the Content personally and for a non-commercial purpose in compliance with these Terms. You may not circumvent copyright, DRM, or other protection measures, nor may you reproduce, distribute, broadcast, modify, or exploit the Content without express written permission from the merchant.
              </p>
              <p className="mb-4">
                The availability and quality of the Content may vary depending on your location, device, and internet connection. The merchant makes no guarantees about quality or uninterrupted access.
              </p>
              <p>
                You may only access the Content in geographic locations where the merchant offers its service and has licensed Content.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-bold text-[#113A28] mb-4">4. Support Services</h2>
              <p>
                Support includes reasonable assistance during regular business hours, updates, and revisions to the Site and Services as the merchant elects to provide.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-bold text-[#113A28] mb-4">5. Fees and Payment</h2>
              <p className="mb-4">
                By registering, you may be offered a trial for a small verification fee. If you cancel within the trial period, only the verification fee will be charged. Otherwise, your membership will automatically extend to a monthly plan.
              </p>
              <p className="mb-4">
                Membership fees will be billed to your chosen payment method each month unless you cancel. Prices and charges are subject to change with notice.
              </p>
              <p className="mb-4">
                Payments are fully earned upon receipt and may not be refunded, except at the sole discretion of the merchant.
              </p>
              <p>
                You are responsible for internet access costs.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-bold text-[#113A28] mb-4">6. Cancellation</h2>
              <p className="mb-4">
                You may cancel your membership at any time and will continue to have access until the end of your billing period. Payments are non-refundable, and no refunds will be given for partial months or unused content.
              </p>
              <p>
                The merchant may issue refunds or credits at its sole discretion, but such decisions do not entitle you to future credits.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-bold text-[#113A28] mb-4">7. Right to Terminate</h2>
              <p>
                The merchant reserves the right to terminate or restrict your use of the service, without notice, for any reason.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-bold text-[#113A28] mb-4">8. Your Responsibilities</h2>
              <p className="mb-4">
                You must use the Services for lawful, non-commercial purposes only. You may not:
              </p>
              <ul className="pl-6 mb-4 space-y-2 list-disc">
                <li>Violate intellectual property rights.</li>
                <li>Use unauthorized automated tools to access the Services.</li>
                <li>Introduce malware or harmful code.</li>
                <li>Circumvent security features.</li>
                <li>Interfere with other users’ enjoyment of the Services.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-bold text-[#113A28] mb-4">9. Suspension/Discontinuation</h2>
              <p>
                The merchant may change, suspend, or discontinue the Services at any time without notice and without liability.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-bold text-[#113A28] mb-4">10. Copyright</h2>
              <p>
                All Content is owned by the merchant or its licensors. You may not reproduce, distribute, or exploit it without permission.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-bold text-[#113A28] mb-4">11. Links to Other Websites</h2>
              <p>
                The Site may contain links to third-party websites. The merchant is not responsible for the content or practices of such websites.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-bold text-[#113A28] mb-4">12. Trademarks</h2>
              <p>
                All trademarks, logos, and product names are the property of the merchant or their respective owners.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-bold text-[#113A28] mb-4">13. Force Majeure</h2>
              <p>
                The merchant is not liable for delays or failures caused by events beyond its reasonable control, such as natural disasters, strikes, or internet outages.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-bold text-[#113A28] mb-4">14. Disclaimer of Warranties</h2>
              <p>
                The Service is provided “as is” without warranties of any kind, express or implied. You use the Site and Service at your own risk.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-bold text-[#113A28] mb-4">15. Age Restriction</h2>
              <p>
                By using this website, you confirm that you are at least 18 years old. Persons under 18 are not permitted to use the Services.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-bold text-[#113A28] mb-4">16. General Provisions</h2>
              <ul className="space-y-4">
                <li>
                  <strong className="text-[#113A28]">Indemnification:</strong> You agree to indemnify the merchant against claims arising from your use of the Services.
                </li>
                <li>
                  <strong className="text-[#113A28]">Severability:</strong> If any provision is held invalid, the remainder remains in effect.
                </li>
                <li>
                  <strong className="text-[#113A28]">No Waiver:</strong> Failure to enforce any provision is not a waiver of rights.
                </li>
                <li>
                  <strong className="text-[#113A28]">Assignment:</strong> You may not assign rights or obligations under these Terms.
                </li>
                <li>
                  <strong className="text-[#113A28]">Entire Agreement:</strong> These Terms constitute the full agreement between you and the merchant.
                </li>
              </ul>
              <p className="mt-6 font-medium">
                This agreement shall be governed by and construed in accordance with the laws of Cyprus.
              </p>
            </section>

          </div>
        </div>
      </main>

    </div>
    
      <Footer />
    </>
  );
};

export default TermsAndConditions;